import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import PublicIcon from '@mui/icons-material/Public';


const emails = ['username@gmail.com', 'user02@gmail.com'];

function SimpleDialog(props) {
    const { onClose, selectedValue, open } = props;

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    return (
        <Dialog onClose={handleClose} open={open} min-width={"200px"} maxWidth={"md"} >
            <DialogTitle>Set Location</DialogTitle>

            <Button variant={props.mapCenterName === "grandCaymanCenter" ? "contained" : "text"} style={{ padding: "4px", margin: "4px", backgroundColor: "#ffffff", color: "#4f4f4f" }} onClick={() => { props.handleIslandRadioChange("grand"); props.onClose() }}>Grand Cayman</Button>
            <Button variant={props.mapCenterName === "littleCaymanCenter" ? "contained" : "text"} style={{ padding: "4px", margin: "4px", backgroundColor: "#ffffff", color: "#4f4f4f" }} onClick={() => {props.handleIslandRadioChange("little"); props.onClose() }}>Little Cayman</Button>
            <Button variant={props.mapCenterName === "caymanBracCenter" ? "contained" : "text"} style={{ padding: "4px", margin: "4px", backgroundColor: "#ffffff", color: "#4f4f4f" }} onClick={() => {props.handleIslandRadioChange("brac"); props.onClose()
}
}>Cayman Brac</Button>


        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

export function SelectPos({ mapCenterName, handleIslandRadioChange }) {
    const [open, setOpen] = React.useState(false);
    const [selectedValue, setSelectedValue] = React.useState(emails[1]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        setSelectedValue(value);
    };

    return (
        <div>
            <Button onClick={handleClickOpen} variant="contained" style={{ backgroundColor: "#ffffff", color: "#4f4f4f", zIndex:"1", textTransform: 'none'}} >
                Island
            </Button>
            <SimpleDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                mapCenterName={mapCenterName}
                handleIslandRadioChange={handleIslandRadioChange}
            />
        </div>
    );
}